import { delay, put, race, take } from 'redux-saga/effects';
import { SEND_NOW, UNDO_MOVE, UNDO_WINDOW_MS } from './constants';
import { undoDone, undoSending, undoWaiting } from './actions';

/**
 * Which moves call this, and when, is decided in one place: undoableMoves.
 *
 * Waits UNDO_WINDOW_MS for an Undo, showing what the move will do (usePendingUndo), and the move done on the board
 * meanwhile (`preview`: a swap, SwapPreview, or an attach, AttachPreview).
 *
 * @returns {boolean} whether the move was undone; if not, the caller puts undoDone once the game has answered
 */
export function* waitForUndo(title, words, preview = {}) {
  yield put(undoWaiting(title, words, preview));
  // Sent when the time runs out, or at once if you're sure (SEND_NOW).
  const { undone } = yield race({ sent: delay(UNDO_WINDOW_MS), now: take(SEND_NOW), undone: take(UNDO_MOVE) });
  // Undone, it's over; sent, the swap stays shown until the game answers (the caller ends it: undoDone).
  yield put(undone ? undoDone() : undoSending());
  return !!undone;
}
